import { Flex, IconButton } from '@wyz/ui';
import { TextField } from '~/common/components';

type BaseFormProps = {
  onCancel: () => void;
  name: string;
  onSubmit?: (e: React.MouseEvent) => void;
};

const BaseForm = ({ onCancel, name, onSubmit }: BaseFormProps) => {
  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter' && onSubmit) {
      e.preventDefault();
      e.stopPropagation();
      onSubmit(e as unknown as React.MouseEvent);
    }
  };

  return (
    <Flex alignItems='start'>
      <TextField
        name={name}
        required
        formGroupClassName=''
        size='xs'
        onKeyDown={handleKeyDown}
      />
      <IconButton
        id='submit-add'
        variant='link'
        className='text-success-text'
        icon='check-mark-line'
        type={onSubmit ? 'button' : 'submit'}
        iconSize='xxs'
        size='sm'
        onClick={onSubmit}
      />
      <IconButton
        id='cancel-add'
        onClick={onCancel}
        variant='link'
        icon='close'
        type='button'
        iconSize='xxs'
        size='sm'
      />
    </Flex>
  );
};

export default BaseForm;
